var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0C58.2129 0 75 16.7871 75 37.5C75 58.2129 58.2129 75 37.5 75C16.7871 75 0 58.2129 0 37.5C0 16.7871 16.7871 0 37.5 0Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5073 50.6836C30.227 50.6836 24.3237 44.7876 24.3237 37.5C24.3237 30.2124 30.227 24.3164 37.5073 24.3164C44.0332 24.3164 49.4531 29.0771 50.4932 35.3027H63.772C62.6514 21.7676 51.3208 11.1328 37.5 11.1328C22.9395 11.1328 11.1328 22.9395 11.1328 37.5C11.1328 52.0605 22.9395 63.8672 37.5 63.8672C51.3208 63.8672 62.6514 53.2324 63.772 39.6973H50.4858C49.4385 45.9229 44.0332 50.6836 37.5073 50.6836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider11);
export default __webpack_public_path__ + "static/media/slider-11.f10ce775a3b15dce683ebce2a548c3dc.svg";
export { ForwardRef as ReactComponent };